<template>
    <div>
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <template v-if="dataCollection.datasets">
            <ul
                class="
                    list
                    d-flex
                    align-items-center
                    justify-content-center
                    gap-4
                    mb-2
                "
            >
                <li
                    v-for="(item, index) in legend"
                    :key="item"
                    class="
                        d-flex
                        align-items-center
                        gap-2
                        text-small
                        font-weight-bold
                    "
                >
                    <span
                        :style="{ backgroundColor: colors[index] }"
                        class="legend-color"
                    />

                    <span>
                        {{ item }}
                    </span>
                </li>
            </ul>

            <line-chart
                ref="chart"
                :height="310"
                :chart-data="dataCollection"
                :options="chartOptions"
                class="chart"
            ></line-chart>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import { LineChart } from '../charts';
import UiSpinner from '../ui/spinner.vue';

export default {
    name: 'WidgetLineChart',
    components: {
        LineChart,
        UiSpinner,
    },
    props: {
        colors: {
            type: Array,
            required: true,
        },
        labels: {
            type: Array,
            required: true,
        },
        legend: {
            type: Array,
            default: () => [],
        },
        url: {
            type: String,
            required: true,
        },
        yAxisMin: {
            type: Number,
            default: 0,
        },
        yAxisMax: {
            type: Number,
            default: undefined,
        },
    },
    data() {
        return {
            chartOptions: {
                elements: {
                    line: {
                        fill: false,
                    },
                    point:{
                        radius: 6,
                    },
                },
                layout: {
                    padding: {
                        top: 1,
                    },
                },
                legend: {
                    display: false,
                },
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            fontColor: '#302e2e',
                            max: this.yAxisMax,
                            maxTicksLimit: 10,
                            min: this.yAxisMin,
                            padding: 20,
                            stepSize: 2,
                        },
                        gridLines: {
                            drawBorder: false,
                            drawTicks: false,
                            zeroLineColor: '#302e2e',
                        },
                    }],
                    xAxes: [{
                        ticks: {
                            padding: 20,
                            fontColor: '#302e2e',
                        },
                        gridLines: {
                            lineWidth: 0,
                            drawTicks: false,
                            zeroLineWidth: 1,
                            zeroLineColor: '#302e2e',
                        },
                    }],
                },
                tooltips: {
                    callbacks: {
                        label: function(t, d) {
                            const dataset = d.datasets[t.datasetIndex];
                            const value = new Intl.NumberFormat().format(dataset.data[t.index].toFixed(1))
                            const label = dataset.titles[t.index];

                            return `${value} (${label})`;
                        }
                    },
                },
            },
            dataCollection: [],
            isLoading: false,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: this.query });

            const dataMapped = data.map((item, index) => {
                return {
                    borderColor: this.colors[index],
                    data: item.map((x) => x.data),
                    titles: item.map((x) => x.label),
                    pointBackgroundColor: this.colors[index],
                };
            });

            this.dataCollection = {
                labels: this.labels,
                datasets: dataMapped,
            };

            this.isLoading = false;
        },
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>

